import React from 'react'

/**
 * View-mode rendering of a spreadsheet cell value — a plain text node with the same padding the
 * editable inputs use, so switching between view and edit modes does not jump the row height.
 * Clicking the cell text activates the cell (mirrors Sheets click-to-select behavior).
 *
 * Empty values render a non-breaking space so the cell keeps its full line-height. Without it, an
 * empty `text` collapses the div to just its padding (~8px) and the row shrinks to half the height
 * of populated rows — visible on the trailing empty row at the bottom of the grid, and on any data
 * row where Value or Unit is empty.
 */
export type SpreadsheetCellViewValueProps = {
  text: string
  onClick?: () => void
}

export const SpreadsheetCellViewValue = ({ text, onClick }: SpreadsheetCellViewValueProps) => (
  <div onClick={onClick} className="px-2 py-1">
    {text || ' '}
  </div>
)
